[
  {
    "code": "OM-DA",
    "name": "A'Dakhiliya"
  },
  {
    "code": "OM-ZA",
    "name": "A'Dhahirah"
  },
  {
    "code": "OM-SS",
    "name": "A'Sharqiyah North"
  },
  {
    "code": "OM-SJ",
    "name": "A'Sharqiyah South"
  },
  {
    "code": "OM-BS",
    "name": "Al Batinah North"
  },
  {
    "code": "OM-BJ",
    "name": "Al Batinah South"
  },
  {
    "code": "OM-BU",
    "name": "Al Buraimi"
  },
  {
    "code": "OM-WU",
    "name": "Al Wusta"
  },
  {
    "code": "OM-ZU",
    "name": "Dhofar"
  },
  {
    "code": "OM-MU",
    "name": "Musandam"
  },
  {
    "code": "OM-MA",
    "name": "Muscat"
  }
]